import React from 'react';
import { Link } from 'react-router-dom';
import Box from 'ui/Box/Box';
import Flex from 'ui/Flex/Flex';
import Text from 'ui/Text/Text';
import { FiLink2 } from 'react-icons/fi';
import Styles from './MCPSection.module.scss';

const MCPSection = () => {
  return (
    <Box
      as="section"
      id="MCPSection"
      direction="column"
      align="center"
      gap="48"
      color="sunset"
      margins
      css={{ padding: '60px 24px', textAlign: 'center' }}
    >
      <Flex direction="column" align="center" gap="16" css={{ maxWidth: '800px' }}>
        <div className={Styles.logos}>
          <div className={Styles.logoBadge}>
            <img src="/favicon.png" alt="Vocable" className={`${Styles.logoImg} ${Styles.vocableLogo}`} />
          </div>
          <div className={Styles.connectorIcon}>
            <FiLink2 size={16} />
          </div>
          <div className={Styles.logoBadge}>
            <img src="/Images/mcp/claude-logo.png" alt="Claude" className={Styles.logoImg} />
          </div>
        </div>
        <Text as="h2" heading="1" className={Styles.heading}>
          Your content OS, inside your{' '}
          <span className={Styles.highlight}>AI agent</span>
        </Text>
        <Text as="p" size="lg" className={Styles.description}>
          Connect Vocable to Claude Chat and Cowork with our MCP connector.
          Plan campaigns, draft in your brand voice, manage your library,
          publish to every channel, and collaborate with your team — all from
          inside the AI conversation. Your Brand DNA rides along with every call.
        </Text>
      </Flex>

      <Flex gap="32" justify="center" className={Styles.stats}>
        <div className={Styles.stat}>
          <span className={Styles.statNumber}>38</span>
          <span className={Styles.statLabel}>tools</span>
        </div>
        <div className={Styles.stat}>
          <span className={Styles.statNumber}>17</span>
          <span className={Styles.statLabel}>workflow prompts</span>
        </div>
        <div className={Styles.stat}>
          <span className={Styles.statNumber}>9</span>
          <span className={Styles.statLabel}>brand resources</span>
        </div>
      </Flex>

      <Link to="/mcp" className={Styles.cta}>
        Explore the MCP Connector
      </Link>
    </Box>
  );
};

export default MCPSection;
